.custom-page-loader {
  display: flex;
  justify-content: center;
  align-items: center;

  &--viewport-height {
    height: 100vh;
  }
}
